<div class="container-fluid">
    <div class="row mt-2 mb-2">
        <div class="col-12">

            <mat-card appearance="outlined" class="mat-elevation-z2">
                <mat-card-title>Calendario turnos</mat-card-title>
                <mat-card-subtitle>
                    <p>En esta sección se muestra el calendario de turnos para el mes indicado.</p>
                </mat-card-subtitle>

                <mat-card-content>
                    <!-- Navegación del mes -->
                    <div class="navegacion-mes mb-4">
                        <button mat-raised-button mwlCalendarPreviousView color="primary" [view]="view"
                            [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()" (click)="mesAnterior()">
                            <mat-icon>chevron_left</mat-icon>
                            Mes anterior
                        </button>
                        <button mat-raised-button color="accent" class="mx-2">
                            {{ viewDate | date:'MMMM yyyy' | titlecase }}
                        </button>
                        <button mat-raised-button mwlCalendarNextView color="primary" [view]="view"
                            [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()" (click)="mesSiguiente()">
                            Mes siguiente
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>

                    <!-- Calendario -->
                    <mwl-calendar-month-view [viewDate]="viewDate" [events]="TurnosService.listaDiasTrabajo$ | async"
                        [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" [activeDay]="viewDay"
                        (dayClicked)="dayClicked($event.day)" locale="es" [weekStartsOn]="1"
                        (eventClicked)="handleEvent('Clicked', $event.event)" [cellTemplate]="customCellTemplate">
                    </mwl-calendar-month-view>

                    <!-- Leyenda de empleados -->
                    <div class="mt-4">
                        <h4>Leyenda de empleados</h4>
                        <div class="empleados-grid">
                            <div class="empleado-item" *ngFor="let empleado of TurnosService.empleados$ | async; trackBy: trackByIndex">
                                <div class="d-flex flex-column">
                                    <!-- Estado normal del empleado -->
                                    <div class="d-flex align-items-center mb-1"
                                        *ngIf="!TurnosService.empleadoTieneVacaciones(empleado) && !TurnosService.empleadoTieneBaja(empleado)">
                                        <div class="empleado-color" [style.background-color]="empleado.color.primary">
                                        </div>
                                        <div class="ms-2">
                                            <span> {{empleado.nombre}}</span>
                                        </div>
                                    </div>

                                    <!-- Estado de vacaciones del empleado -->
                                    <div class="d-flex align-items-center"
                                        *ngIf="TurnosService.empleadoTieneVacaciones(empleado)">
                                        <div class="empleado-color empleado-color-vacaciones"
                                            [style.background-color]="'#fff'"></div>
                                        <div class="ms-2">
                                            <span class="texto-vacaciones">{{empleado.nombre}} (Vacaciones)</span>
                                        </div>
                                    </div>

                                    <!-- Estado de baja del empleado -->
                                    <div class="d-flex align-items-center"
                                        *ngIf="TurnosService.empleadoTieneBaja(empleado)">
                                        <div class="empleado-color empleado-color-baja"
                                            [style.background-color]="'#ff0000'"></div>
                                        <div class="ms-2">
                                            <span class="texto-baja">{{empleado.nombre}} (Baja)</span>
                                        </div>
                                    </div>

                                    <!-- Estado de asuntos propios del empleado -->
                                    <div class="d-flex align-items-center"
                                        *ngIf="TurnosService.empleadoTieneAsuntosPropios(empleado)">
                                        <div class="empleado-color empleado-color-asuntos-propios"
                                            [style.background-color]="'#00ff00'"></div>
                                        <div class="ms-2">
                                            <span class="texto-asuntos-propios">{{empleado.nombre}} (Asuntos
                                                propios)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
    <small style="margin: 5px" *ngIf="day.events.length > 10">Hay {{ day.events.length }} turnos en este día</small>
    <div class="d-flex flex-wrap mt-1" *ngIf="day.events.length > 0 && day.events.length <= 10">
        <div *ngFor="let event of day.events; trackBy: trackByIndex" [ngClass]="event.cssClass"
            [style.background-color]="event.meta?.vacaciones ? event.color.secondary : event.color.primary"
            [style.border-radius]="event.meta?.vacaciones ? '0' : '5px'" class="cal-event" matTooltip="{{event.title}}"
            matTooltipPosition="above">
        </div>
    </div>
</ng-template>